import { useEffect, useState } from "react"
import { Alert, AlertTitle } from "@mui/material"
import {
  VisibilityOutlined as VisibilityOutlinedIcon,
  Lock as LockIcon,
} from "@mui/icons-material"

import RestrictedWordsTable from "./RestrictedWordsTable"
import RestrictedWordsModal from "./RestrictedWordsModal"
import DeleteRestrictedWordsModal from "./DeleteRestrictedWordsModal"
import { useRestrictedWords } from "./useRestrictedWords"
import { getEnterprise } from "../../../services/scout"
import { isAccountBlocked, renderKeywords } from "../../../services/utils"

const RestrictedWordsPage = () => {
  const {
    items,
    editing,
    deleting,
    setEditing,
    setDeleting,
    save,
    remove,
  } = useRestrictedWords()

  const [showModal, setShowModal] = useState(false)
  const [isBlocked, setIsBlocked] = useState(false)
  const [shouldRenderContent, setShouldRenderContent] = useState(true)

  useEffect(() => {
    const loadEnterprise = async () => {
      const data = await getEnterprise()
      setIsBlocked(isAccountBlocked(data))
      setShouldRenderContent(renderKeywords(data))
    }

    void loadEnterprise()
  }, [])

  const handleEdit = (item) => {
    if (isBlocked) return
    setEditing(item)
    setShowModal(true)
  }

  const handleAdd = () => {
    if (isBlocked) return
    setEditing(null)
    setShowModal(true)
  }

  const handleDelete = (item) => {
    if (isBlocked) return
    setDeleting(item)
  }

  const handleSave = async (payload) => {
    if (isBlocked) return false
    const ok = await save(payload)
    if (ok) {
      setShowModal(false)
      setEditing(null)
    }
    return ok
  }

  const handleRemove = async (item) => {
    if (isBlocked) return false
    const ok = await remove(item)
    if (ok) {
      setDeleting(null)
    }
    return ok
  }

  return (
    <>
      {shouldRenderContent
        ? <section className="scout-settings-section">
          <div className="scout-settings-section__label">
            <VisibilityOutlinedIcon />
            <span>Palavras-chave monitoradas</span>
          </div>

          <RestrictedWordsTable
            items={items}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onAdd={handleAdd}
            disabled={isBlocked}
          />
        </section>
        : <Alert severity="info" icon={<LockIcon fontSize="inherit" />}>
          <AlertTitle>Recurso indisponível no seu plano.</AlertTitle>
        </Alert>
      }

      {showModal && !isBlocked ? (
        <RestrictedWordsModal
          open={showModal}
          onClose={() => {
            setShowModal(false)
            setEditing(null)
          }}
          initialValue={editing}
          onSubmit={handleSave}
          submitLabel={editing ? "Salvar" : "Criar"}
        />
      ) : null}

      {!isBlocked ? (
        <DeleteRestrictedWordsModal
          open={Boolean(deleting)}
          item={deleting}
          onClose={() => setDeleting(null)}
          onConfirm={handleRemove}
        />
      ) : null}
    </>
  )
}

export default RestrictedWordsPage
